module.exports = {
	"id": "AZ",
	"name": "Azerbaijan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.024185,
			"5": 0.029022,
			"6": 0.024185,
			"7": 0.014511,
			"8": 0.043533,
			"9": 0.033859,
			"10": 0.033859,
			"11": 0.062881,
			"12": 0.043533,
			"13": 0.038696,
			"14": 0.053207,
			"15": 0.04837,
			"16": 0.04837,
			"17": 0.058044,
			"18": 0.053207,
			"19": 0.033859,
			"20": 0.043533,
			"21": 0.058044,
			"22": 0.198317,
			"23": 0.072555,
			"24": 0.053207,
			"25": 0.033859,
			"26": 0.082229,
			"27": 0.067718,
			"28": 0.033859,
			"29": 0.033859,
			"30": 0.014511,
			"31": 0.04837,
			"32": 0.029022,
			"33": 0.024185,
			"34": 0.043533,
			"35": 0.067718,
			"36": 0.024185,
			"37": 0.038696,
			"38": 0.072555,
			"39": 0.101577,
			"40": 0.106414,
			"41": 0.053207,
			"42": 0.062881,
			"43": 0.183806,
			"44": 0.062881,
			"45": 0.082229,
			"46": 0.058044,
			"47": 0.091903,
			"48": 0.140273,
			"49": 2.336271,
			"50": 0.125762,
			"51": 0.488537,
			"52": 0.493374,
			"53": 19.8317,
			"54": 5.886629,
			"55": 0.116088,
			"56": 0.029022,
			"57": null
		},
		"firefox": {
			"2": 0.038696,
			"3": 0.09674,
			"4": 0.029022,
			"5": 0.004837,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.024185,
			"11": 0.029022,
			"12": 0.014511,
			"13": 0.014511,
			"14": 0.014511,
			"15": 0.019348,
			"16": 0.004837,
			"17": 0.004837,
			"18": 0.014511,
			"19": 0.009674,
			"20": 0.019348,
			"21": 0.019348,
			"22": 0.014511,
			"23": 0.004837,
			"24": null,
			"25": 0.014511,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.004837,
			"30": 0.009674,
			"31": 0.014511,
			"32": 0.009674,
			"33": 0.019348,
			"34": 0.004837,
			"35": 0.024185,
			"36": 0.024185,
			"37": null,
			"38": 0.009674,
			"39": 0.004837,
			"40": 0.009674,
			"41": null,
			"42": null,
			"43": 0.033859,
			"44": 0.038696,
			"45": 0.024185,
			"46": 0.024185,
			"47": 0.164458,
			"48": 0.09674,
			"49": 1.102836,
			"50": 0.014511,
			"51": null,
			"52": null,
			"3.5": 0.135436,
			"3.6": 0.449841
		},
		"opera": {
			"9": null,
			"11": 0.024185,
			"12": 0.261198,
			"15": 0.029022,
			"16": 0.014511,
			"17": 0.019348,
			"18": 0.029022,
			"19": 0.014511,
			"20": 0.038696,
			"21": 0.014511,
			"22": null,
			"23": 0.004837,
			"24": 0.004837,
			"25": 0.019348,
			"26": 0.009674,
			"27": 0.135436,
			"28": 0.019348,
			"29": 0.019348,
			"30": 0.024185,
			"31": 0.009674,
			"32": 0.009674,
			"33": 0.014511,
			"34": 0.019348,
			"35": 0.033859,
			"36": 0.19348,
			"37": 0.106414,
			"38": 0.087066,
			"39": 0.091903,
			"40": 2.524914,
			"41": 0.464352,
			"42": 0.004837,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.019348,
			"10.5": 0.024185,
			"10.6": 0.067718,
			"11.1": 0.033859,
			"11.5": 0.053207,
			"11.6": 0.164458,
			"12.1": 0.865823
		},
		"safari": {
			"0": null,
			"4": 0.082229,
			"5": 0.116088,
			"6": 0.014511,
			"7": 0.009674,
			"8": 0.140273,
			"9": 0.038696,
			"10": 0.203154,
			"3.1": 0.009674,
			"3.2": 0.009674,
			"5.1": 0.067718,
			"6.1": 0.014511,
			"7.1": 0.004837,
			"9.1": 0.178969
		},
		"ios_saf": {
			"8": 0,
			"10": 4.91999938551,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.132588290383,
			"8.1-8.4": 0.244951248335,
			"9.0-9.2": 0.11685747627,
			"9.3": 1.7828255995
		},
		"android": {
			"3": 0,
			"4": 0.116641108527,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0145801385659,
			"4.1": 0.420741141473,
			"4.2-4.3": 1.05185285368,
			"4.4": 2.41197149419,
			"4.4.3-4.4.4": 2.43280026357
		},
		"ie": {
			"6": null,
			"7": 0.00532593862816,
			"8": 0.324882256318,
			"9": 0.207711606498,
			"10": 0.250319115523,
			"11": 0.687046083032,
			"5.5": null
		},
		"op_mob": {
			"0": 0.501680279515,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0139355633199
		},
		"edge": {
			"12": 0.019348,
			"13": 0.135436,
			"14": 0.140273
		},
		"ie_mob": {
			"10": 0.0997695211268,
			"11": 0.406204478873
		},
		"bb": {
			"7": 0.04517625,
			"10": null
		},
		"samsung": {
			"0": 4.641537
		},
		"and_uc": {
			"0": 0.660864
		},
		"op_mini": {
			"0": 6.75905115716
		},
		"and_chr": {
			"0": 25.950089
		},
		"and_ff": {
			"0": 0.015489
		}
	},
	"total": 95.41645625
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AZ.json
 ** module id = 470
 ** module chunks = 0
 **/